<template>
  <div class="legacy">
    <Loader v-if="loading" />
    <div v-else class="box">
      <div class="overflow-hidden overflow-x-auto relative">
        <table v-if="hasInvoices" class="table w-full" cellpadding="0" cellspacing="0">
          <thead>
          <tr>
            <th class="text-left">{{ $t('Date') }}</th>
            <th class="text-left">{{ $t('Amount') }}</th>
            <th class="hidden medium:table-cell">&nbsp;<!-- Download --></th>
          </tr>
          </thead>
          <tbody>
              <tr
              v-for="(invoice, index) in invoices.data"
              :key="`tableRow_${index}`"
              >
                <td>{{ $d(invoice.date * 1000, 'shortDate') }}</td>
                <td>
                  {{
                    $n(invoice.amount / 100, {
                      key: 'currency',
                      currencyCode: invoice.currency,
                    })
                  }}
                </td>
                <td class="text-right">
                  <a :href="invoice.pdf" class="text-green">
                    {{ $t('Download invoice as PDF') }}
                  </a>
                </td>
              </tr>
          </tbody>
        </table>
        <div v-else>
          {{ $t('No previous invoices') }}
        </div>
      </div>
    </div>
  </div>

</template>

<script>
  import { mapActions, mapGetters } from 'vuex';
  import Loader from '@/_legacy/components/Icons/Loader';

  export default {
    name: 'Invoices',

    components: {
      Loader,
    },

    data() {
      return {
        loading: true,
      };
    },

    computed: {
      ...mapGetters({
        invoices: 'subscription/invoices',
      }),
      hasInvoices() {
        return this.invoices.data && this.invoices.data.length;
      }
    },

    created() {
      this.getInvoices()
        .then(() => {
          this.loading = false;
        });
    },

    methods: {
      ...mapActions({
        getInvoices: 'subscription/getInvoices',
      }),
    },
  };
</script>
